import axios from "axios";
import { showNotify } from 'vant';

const request = axios.create({
    baseURL: process.env.VUE_APP_API_ROOT,
    timeout: 10000
})

request.interceptors.request.use(config => {
    config.headers['lang-admin'] = sessionStorage.getItem('language')
    const token = sessionStorage.getItem('token')
    if(token) {
        config.headers['like-admin'] = token
    }
    return config
}, err => {
    return Promise.reject(err)
})

request.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    switch(code) {
        case 200:
            return res.data
        case 333:
            sessionStorage.removeItem('token')
            return
        case 332:
            sessionStorage.removeItem('token')
            return
        case 501:
            showNotify({ type: 'warning', message: `${res.data.msg}` });
            return Promise.reject(res.data)
        default:
            showNotify({ type: 'danger', message: `${res.data.msg}` });
            return Promise.reject(res.data)
    }
}, err => {
    return Promise.reject(err)
})

export default request
